import React, { useEffect, useRef, useState } from "react";
import { FilmSlate, Eye, EyeSlash, ArrowClockwise } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { IntroVideo } from "../components/IntroVideo";

export const IntroVideoAdmin = () => {
  const [status, setStatus] = useState({ active: true });
  const [previewKey, setPreviewKey] = useState(0);
  const loading = useRef(false);

  const load = () =>
    api
      .get("/admin/intro-video/status")
      .then((r) => setStatus(r.data))
      .catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const toggle = async () => {
    if (loading.current) return;
    loading.current = true;
    try {
      await api.put(`/admin/intro-video/toggle?active=${!status.active}`);
      toast.success(!status.active ? "Intro activada" : "Intro desactivada");
      load();
    } catch {
      toast.error("Error al actualizar");
    } finally {
      loading.current = false;
    }
  };

  const replay = () => {
    sessionStorage.removeItem("cg_intro_seen");
    setPreviewKey((k) => k + 1);
  };

  return (
    <div className="max-w-3xl space-y-8" data-testid="intro-admin">
      <div className="border border-white/10 bg-[#111] p-6">
        <div className="flex items-center gap-3 mb-2">
          <FilmSlate size={26} weight="duotone" className="text-[#D97736]" />
          <h3 className="font-display text-3xl">Intro animada</h3>
        </div>
        <p className="text-gray-400 text-sm mb-6 leading-relaxed">
          Una animación de marca <span className="text-white">exclusiva de Ciudad Garaje</span> — con
          efecto de puerta de garaje y el sello CG — que aparece al entrar a la web y se desvanece sola.
          Se muestra <span className="text-white">una vez por visita</span>. No usa video ni sonido, así
          que carga al instante y se ve perfecta en todos los navegadores y celulares.
        </p>

        <div className="flex items-center justify-between border-t border-white/10 pt-5">
          <span
            className={`text-xs uppercase tracking-wide px-3 py-1.5 ${
              status.active
                ? "text-green-400 border border-green-500/40"
                : "text-gray-500 border border-white/10"
            }`}
            data-testid="intro-status-badge"
          >
            {status.active ? "Intro ACTIVA" : "Intro desactivada"}
          </span>
          <button
            onClick={toggle}
            className="flex items-center gap-2 border border-white/15 hover:border-[#D97736] hover:text-[#D97736] px-4 py-2 text-sm uppercase tracking-wide"
            data-testid="intro-toggle-btn"
          >
            {status.active ? (
              <>
                <EyeSlash size={16} /> Desactivar
              </>
            ) : (
              <>
                <Eye size={16} /> Activar
              </>
            )}
          </button>
        </div>
      </div>

      <div className="border border-white/10 bg-[#111] p-6">
        <div className="flex items-center justify-between mb-4">
          <h4 className="overline">Vista previa</h4>
          <button
            onClick={replay}
            className="flex items-center gap-2 text-sm text-gray-300 hover:text-[#D97736]"
            data-testid="intro-replay-btn"
          >
            <ArrowClockwise size={16} weight="bold" /> Reproducir de nuevo
          </button>
        </div>
        <p className="text-gray-500 text-xs mb-4">
          Así se verá la intro al entrar a la web. Pulsa "Reproducir de nuevo" para volver a verla.
        </p>
        <IntroVideo key={previewKey} />
      </div>
    </div>
  );
};
